import { ReactionsBar } from 'src/components/reactionsBar'
import { LIVE_POST_IMG } from 'src/assets/svg'
import { CounterComments } from 'src/pages/CommunityDetails/Posts/components/counterComments'
import PostInfo from 'src/pages/CommunityDetails/Posts/PostItem/PostInfo'
import { Container } from 'src/pages/CommunityDetails/Posts/PostItem/postItem.styles'

import { LiveBadge } from '../liveBadge'
import { LiveHeader } from '../liveHeader'
import { LiveStatus } from '../../types'
import { LivePublicationProps } from './livePublication.types'
import { ImageBox, InfoBox, Item } from './livePublication.styles'

const LivePublication = ({
  authorContent,
  post,
  actionsSection,
  unsupportedContentSection,
  onClick
}: LivePublicationProps) => {
  return (
    <Container className="_px-3">
      <div className="_py-4 _border-bottom" data-test="button-open-bottomsheet">
        <div className="_cursor-pointer" data-test="div-bottomsheet" onClick={onClick}>
          <div className="_pb-4 _d-flex _justify-content-between">
            {authorContent}
            <div className="_d-flex">{actionsSection}</div>
          </div>

          <Item className="_d-flex _align-items-end">
            <InfoBox className="_flex-1">
              <LiveHeader
                isHighlight={post.live?.status === LiveStatus.STARTED}
                liveDetail={post.live}
              />
              <PostInfo
                title={post.title}
                description={post?.description}
                mentions={post?.mentions}
              />
            </InfoBox>

            <ImageBox className="_overflow-hidden">
              <img
                src={post.live?.thumbnail ?? LIVE_POST_IMG}
                alt=""
                className="_rounded _max-w-full"
                loading="lazy"
                data-test="image-post"
              />
              <LiveBadge className="sticker" />
            </ImageBox>
          </Item>
          {unsupportedContentSection}
        </div>

        {post.reactions && (
          <ReactionsBar
            showAnimation={post.hasUnseenReactions}
            postId={post.id}
            reactionsParam={post.reactions}
          />
        )}

        {post.commentsCount ? <CounterComments counter={post.commentsCount} /> : null}
      </div>
    </Container>
  )
}

export default LivePublication
